// extracted by mini-css-extract-plugin
export default {"panel--wrapper":"MapPane_panel--wrapper__DJx2s","panel--map":"MapPane_panel--map__ll6nj","mobile-controls-toggle":"MapPane_mobile-controls-toggle__I2DKv"};